import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { DevFinanceDealService } from "@js/services/Deal/DevFinanceDealService";
import { SharedDealService } from "@js/services/Deal/SharedDealService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import angular from "angular";
import {
  AccountClient,
  AddressLookupDTO,
  ApplicationUser,
  ApplicationUserCrudClient,
  AppraisalModuleEnum,
  AreaUnitEnum,
  BrickflowEventLogClient,
  CaseAccessLevelEnum,
  CaseChangedMessageDTO,
  CaseLenderStateEnum,
  CaseStatusEnum,
  Client,
  DealClient,
  DealClientClient,
  DealFileAttachment,
  DealFileAttachmentClient,
  DealLender,
  DealLenderClient,
  DealSchedule,
  DealScheduleClient,
  DevelopmentFinanceDeal,
  DevelopmentFinanceDealClient,
  DevelopmentFinanceDealCrudClient,
  DevelopmentFinanceDealUpdate,
  EventLogEnum,
  ExternalLinks,
  ExternalLinksClient,
  Lender,
  LenderClient,
  LenderInfo,
  LenderProductTypeEnum,
  ModuleEnum,
  Organisation,
  OrganisationClient,
  OwnershipRoleEnum,
  OwnOrPurchaseEnum,
  PostalAddress,
  PreAgreementEnum,
  ProductFamilyEnum,
  PromoteSearchToCaseResponse,
  SaveDevFinanceSearchRequest,
  ScheduleDescriptionTypeEnum,
  ScheduleTypeEnum,
  ShareModuleRequest,
  StreetAddressClient,
  SubmitToLendersRequest,
  SwaggerException,
  TenureEnum,
  UserSimpleDTO,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { UserDashboardService } from "@js/services/UserDashboardService";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import ProductHelper from "@js/helpers/ProductHelper";
import { BaseCaseController } from "@js/controllers/BaseCaseController";
import { IndexService } from "@js/services/IndexService";
import { ErrorCodes } from "@js/errorCode";
import { EditorSettings } from "tinymce";

interface LeaseItemDetails {
  TimeLeftOnLeaseYears?: number;
  TimeLeftOnLeaseMonths?: number;
  GrossMonthlyRentalIncome: "";
}

export class DevFinanceCaseController extends BaseCaseController<DevelopmentFinanceDeal> {
  isCaseDashboard: boolean = true;

  dataLoading: boolean;
  dealDto: DevelopmentFinanceDeal;
  tempDealDto: DevelopmentFinanceDeal;
  orgName: string;
  orgId: number;
  org: Organisation;
  fileNamePrefix: string = "Brickflow";
  mortgageTerm: number = 0;

  selectedNavMenu: number = 0;

  dealForm: ng.IFormController;

  lenderDetailsForm: ng.IFormController;

  ownershipType: string = "";

  currentApplicant: DealClient;
  tempApplicant: DealClient;
  applicantList: DealClient[] = [];

  searchterm: string;
  previousAddressSearchTerm: string;
  postCodeOptions: PostalAddress[] = [];
  previousAddressPostCodeOptions: PostalAddress[] = [];
  address: PostalAddress;
  searchingForAddress: boolean = false;
  searchingForPreviousAddress: boolean = false;
  searchresults: string = "";
  previousAddressSearchResults: string[];

  tenureTypes = [];
  //maritalStatusOptions = [];
  ownOrPurchaseOptions = [];
  ownNewDevelopmentOptions = [];
  yesNoOptions = [];
  planningOptions = [];
  titleOptions = [];
  ownershipRoleOptions = [];
  //countryList = [];
  //nationalityList = [];
  //countryOfBirthList = [];
  //countryOfResidenceList = [];
  loanCompletionTypeOptions = [];
  currentUseofBuildingOptions = [];
  loanRepaymentTypeOptions = [];
  productTypeOptions = [];
  fixedrateTermOptions = [];
  locationOptions = [];
  planningStatusAtEndOfDevOptions = [];
  planningResponsibilityOptions = [];
  buildProcurementTypeOptions = [];
  exitStrategyOptions = [];

  //modal
  message: string = "";
  modal: boolean = false;
  showErrorMessage: boolean = false;

  uploadingFiles: FileUploadProgressDTO[];
  fileUpload: DealFileAttachment[];
  applicantTrackRecordFiles: DealFileAttachment[];
  propertyFiles: DealFileAttachment[];
  total: number = 0;
  renamingFile: DealFileAttachment;

  // Controls showing Ts & Cs when a borrower/broker submits to lenders
  showTsAndCs: boolean = false;
  showApplyTsAndCs: boolean = false;
  showTsAndCsForm: boolean = false;
  messagebool: boolean = false;
  invalidEmail: boolean = false;

  isSubmitted: boolean = false;

  isSubmittedToLenders: boolean = false;

  //Boolean to enable a re-submit button
  hasShortlistedDealLenders: boolean = false;

  selectedLendersName: string = "";
  shortlistedLendersName: string = "";

  //Sharing case
  shareContext: AppraisalModuleEnum = null;
  caseMembersWithAccess: Client[];
  showShare: boolean = false;
  selectedClientToShareWith: Client;
  shareNote: string;
  showModuleShareConfirmation: boolean;

  //show profile view
  showAppraisalPermission: boolean = false;

  //profile
  newApplicant: DealClient;

  maxDateOfBirth: Date = new Date();
  minDateOfBirth: Date = new Date("Jan 01 1900");
  maxDateForDateField: Date = new Date("Jan 01 3000");
  showAddorEdit: boolean = false;
  disableQuickEditSave: boolean = false;
  applicantForm: ng.IFormController;
  isAddShareholder: boolean = false;
  showDelete: boolean = false;
  confirmDeleteApplicant: DealClient;

  showExport: boolean = false;
  updatingName: boolean = false;
  orginalDealName: string;

  isLoggedInUser: boolean = false;

  showBridgingDeal: boolean = true;
  classUses: {} = {};

  tinymceOptionsTrackRecord: EditorSettings;
  missingAddressGaps: string[];

  ownOrPurchase: boolean;
  isFamilyInResidence: boolean;

  dateProperties = ["expiryDate"];

  profileDateProperties = [
    "dateOfBirth",
    "currentAddressFrom",
    "ukResidenceIssueDate",
    "currentEmploymentStartDate",
    "addressStartDate",
  ];

  dealDateProperties = ["originalPurchaseDate", "completionDate"];

  clientDateProperties = ["dateOfBirth"];

  maxPurchaseDate: string;
  minPurchaseDate: Date = new Date("Jan 01 1900");
  dealProductTypeDisplayText: string;
  totalGrossMonthlyRentalIncome: number = 0;
  isGrossMonthlyRentalIncomeMatch: boolean = true;
  showDeal: boolean = true;

  openTrackRecordUploadModal: boolean = false;

  //Sales section
  totalSalesCost: number;
  totalNetDevelopmentVal: number;

  //Property/property
  totalPurchaseCosts: number;
  // Property/build costs
  hasBuildCostsChanged: boolean = false;
  totalBreakdownProfessionalCosts: number;
  totalProjectCosts: number;
  buildCostPerSqFt: number;
  buildCostPerSqM: number;
  buildCostIntermediary: number;
  areaConversionFactor: number = 10.7639;
  contingencyValue: number;
  totalBuildCosts: number;
  buildCostsForm: ng.IFormController;

  //Schedule
  showUnitTypeOptions: boolean = false;
  selectedUnitType: ScheduleTypeEnum = null;
  // scheduleTenureOptions = [];
  preAgreementTypeOptions = [];
  // flatDescriptionTypeOptions = [];
  //houseDescriptionTypeOptions = [];
  newScheduleData: DealSchedule;
  houses: DealSchedule[] = [];
  flats: DealSchedule[] = [];
  parking: DealSchedule[] = [];
  commercial: DealSchedule[] = [];
  scheduleData: DealSchedule[] = [];
  newScheduleDataPricePerUnit: number = 0;

  totalScheduleUnitsGDV: number = 0;
  totalScheduleUnitsArea: number = 0;
  tempGDV: number = 0;
  tempAreaAcquisition: number = 0;
  tempScheduleData: DealSchedule;
  showScheduleUnitDeleteConfirmation: boolean = false;
  showSuccessorFailureMessage: boolean = false;

  //Property section validity
  isPropertySectionInvalidToSave: boolean = false;

  //property for roles directive to handle referred readonly view for broker/connect broker
  isReadOnlyDeal: boolean = true;
  hasFirstLoadOccurred: boolean = false;

  referredPackagerText: string;

  shortListedLendersId: number[];
  lendersDetailsForSubmittoLenders: LenderInfo[];

  //SubmitToLender modal
  brokerCommission: number;
  brokerPreferredContact: string;
  isBrokerPhoneNumberUpdated: boolean = false;
  dealBrokerUser: ApplicationUser;
  totalUnreadDealLenderMessages: number = null;
  offPanelLenderNames: string;

  //Lender Portal Links
  dealLenders: DealLender[];
  dealLendersWithPortalLinkEnabled: DealLender[];
  lendersWithPortalLinkEnabled: Lender[];
  showLenderPortalLinks: boolean = false;
  portalLinks: {} = {};
  borrowerDetails: UserSimpleDTO;
  applicationForm: ng.IFormController;
  portalLinkDetailsAdded: {} = {};

  isDeallockerIntegrationEnabled: boolean = false;
  showMaximumApplicantsMessage: boolean = false;

  static $inject = [
    "$rootScope",
    "$routeParams",
    "$location",
    "$cookies",
    "AccountClient",
    "StreetAddressClient",
    "DevFinanceDealService",
    "DevelopmentFinanceDealClient",
    "AuthService",
    "SelectListService",
    "RoleService",
    "LenderClient",
    "CaseService",
    "DealLenderClient",
    "DealFileAttachmentHelper",
    "DealFileAttachmentClient",
    "$window",
    "ExternalLinksClient",
    "DealClientClient",
    "OrganisationClient",
    "$scope",
    "$sce",
    "DealClient",
    "SharedDealService",
    "DealScheduleClient",
    "UserDashboardService",
    "BrickflowEventLogClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "DevelopmentFinanceDealCrudClient",
    "$timeout",
  ];

  constructor(
    $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    accountClient: AccountClient,
    streetAddressClient: StreetAddressClient,
    private devFinanceDealService: DevFinanceDealService,
    private developmentFinanceDealClient: DevelopmentFinanceDealClient,
    private authService: AuthService,
    selectListService: SelectListService,
    roleService: RoleService,
    private lenderClient: LenderClient,
    private caseService: CaseService,
    dealLenderClient: DealLenderClient,
    private dealFileAttachmentHelper: DealFileAttachmentHelper,
    private dealFileAttachmentClient: DealFileAttachmentClient,
    $window: ng.IWindowService,
    private externalLinksClient: ExternalLinksClient,
    private dealClientClient: DealClientClient,
    private organisationClient: OrganisationClient,
    $scope: ng.IScope,
    private $sce: ng.ISCEService,
    dealClient: DealClient,
    sharedDealService: SharedDealService,
    private dealScheduleClient: DealScheduleClient,
    private userDashboardService: UserDashboardService,
    private eventLogClient: BrickflowEventLogClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private developmentFinanceCrudDealClient: DevelopmentFinanceDealCrudClient,
    $timeout: ng.ITimeoutService,
  ) {
    super(
      sharedDealService,
      indexService,
      accountClient,
      dealClient,
      selectListService,
      $location,
      $rootScope,
      roleService,
      applicationUserCrudClient,
      dealLenderClient,
      $timeout,
      streetAddressClient,
      $window,
      $scope,
    );
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;
    }
    this.maxPurchaseDate = new Date().toISOString().split("T")[0];
    this.tinymceOptionsTrackRecord = this.tinymceOptions = this.sharedDealService.tinymceOptions;
    this.tinymceOptionsTrackRecord.height = undefined;

    if (this.$routeParams.dealId) {
      this.dataLoading = true;

      this.dealId = this.$routeParams.dealId;
      if (this.$routeParams.Promote && this.$routeParams.Promote != "null" && !this.dealDto) {
        const promote = this.$routeParams.Promote as boolean;
        this.isReadOnlyDeal = false;
        this.hasFirstLoadOccurred = true;
        if (promote) {
          this.promoteSearchToCase();
        }
      } else {
        this.dealClient
          .fetchByDealId({
            dealId: this.$routeParams.dealId,
            productFamily: ProductFamilyEnum.Development,
            isCaseDashboardCall: true,
          })
          .then((response) => {
            // The case was a pre-existing case when the broker org became a member of Connect and therefore was archived.
            if (response.devFinanceDeal.isPreConnectArchived) {
              this.$location.path("/dashboard");
            }

            //Below properties are very imp for view roles directive
            this.isReadOnlyDeal = response.isReadOnlyDealForBroker;
            this.hasFirstLoadOccurred = true;
            this.referredPackagerText = response.referredPackagerText;
            this.dealDto = response.devFinanceDeal;
            this.shortlistedLendersName = response.shortlistedLendersName;
            this.selectedLendersName = response.selectedLendersName;
            this.shortListedLendersId = response.shortlistedLendersId;
            this.totalUnreadDealLenderMessages = response.totalUnreadDealLenderMessages;

            if (this.dealDto) {
              this.orgId = this.dealDto.brokerOrganisationId;

              this.postRetrieveProcessing();

              const newShortlist = this.$routeParams.NewShortlist as boolean;
              if (newShortlist) this.getLenderPortalLinks();
            } else {
              // If no case is returned, this could be that the logged in user has been removed from the case
              // - only do this if there is a logged in user, otherwise let the routing sort out where the redirect should go
              if ((this.$rootScope as any).selectedUser) {
                this.$location.path("/dashboard");
              }
            }
          })
          .catch((error: SwaggerException) => {
            if (error.status == ErrorCodes.NotFound) {
              this.message =
                error.response != null && error.response.length > 0
                  ? JSON.parse(error.response)
                  : "Appraisal not found.";
              this.showDeal = false;
            }
          })
          .finally(() => {
            this.hasFirstLoadOccurred = true;
            this.dataLoading = false;
          });
      }
    }

    // this.countryOfBirthList = this.countryOfResidenceList = this.selectListService.GetCountries();
    //this.nationalityList = this.selectListService.GetNationalities();
    this.ownOrPurchaseOptions = this.selectListService.GetOwnOrPurchase();
    //this.maritalStatusOptions = this.selectListService.GetMaritalStatusOptions();
    this.ownNewDevelopmentOptions = this.selectListService.GetOwnNewDevelopmentOptions();
    this.yesNoOptions = this.selectListService.GetYesNoForBridging();
    // this.titleOptions = this.selectListService.GetTitleOptions();
    //this.loanCompletionTypeOptions = this.selectListService.GetLoanCompletionOptions();
    this.ownershipRoleOptions = this.selectListService.GetOwnershipRoleOptions();
    this.loanRepaymentTypeOptions = this.selectListService.GetLoanRepaymentTypeOptions();
    this.productTypeOptions = this.selectListService.GetInterestRateType();
    this.fixedrateTermOptions = this.selectListService.GetFixedRateTermOptions();
    this.locationOptions = this.selectListService.GetLocations();
    // this.planningStatusAtEndOfDevOptions = this.selectListService.GetPlanningStatusAtEndOfDevelopmentOptions(
    //   ProductTypeEnum.Development,
    // );
    //this.planningResponsibilityOptions = this.selectListService.GetPlanningResponsibilityOptions();
    //this.buildProcurementTypeOptions = this.selectListService.GetBuildProcurementTypeOptions();
    //this.exitStrategyOptions = this.selectListService.GetExitStrategyDevFinanceOptions();
    //this.scheduleTenureOptions = this.selectListService.GetSceheduleTenureTypes();
    this.preAgreementTypeOptions = this.selectListService.GetPreAgreementTypes();
    this.getAppName();
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) {
      if (this.isReadOnlyDeal) {
        return `['Admin', 'Client']`;
      } else {
        return `['Admin', 'Client', 'Broker', 'Introducer']`;
      }
    }
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  editDealName() {
    var name = this.dealDto.name;
    this.orginalDealName = name;
    this.updatingName = true;
  }

  cancelEditDealName() {
    this.updatingName = false;
    this.dealDto.name = this.orginalDealName;
  }

  postRetrieveProcessing() {
    if (this.dealDto.projectDescription) {
      this.caseOverview = this.dealDto.projectDescription;
    }

    this.populateAddressField();

    if (this.$routeParams.selectedNavMenu) {
      this.selectedNavMenu = this.$routeParams.selectedNavMenu;
    }

    this.dealLenderClient.fetchByDealId(this.$routeParams.dealId).then((dls: DealLender[]) => {
      this.hasShortlistedDealLenders = dls.some((dl) => dl.status == CaseLenderStateEnum.Shortlisted);
    });

    //These are used for directive.
    (this.$rootScope as any).statusRequirementId = this.dealDto.id;
    this.caseService.updateCaseState(this.dealDto.id, this.dealDto.status);
    this.loadUserRolesAndDealIntegration();
    this.fileUpload = this.dealDto.attachments;
    this.applicantList = this.dealDto.dealClients;
    //this.scheduleData = this.dealDto.dealSchedules;
    this.tenureTypes = this.selectListService.GetTenureTypes(this.dealDto.productType);
    this.dealProductTypeDisplayText = ProductHelper.getProductTypeDisplayText(this.dealDto.productType);
    this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.dealDto.productType);
    this.offPanelLenderNames = this.dealDto.offPanelLenderNames;
    // this.CalcTotalPurchaseCosts();

    this.buildCostPerSqFt = this.dealDto.areaUnit == AreaUnitEnum.SquareFeet ? this.dealDto.buildCostPerArea : null;
    this.buildCostPerSqM = this.dealDto.areaUnit == AreaUnitEnum.SquareMeters ? this.dealDto.buildCostPerArea : null;
    this.buildCostIntermediary = this.dealDto.buildCosts;
    this.offPanelLenderNames = this.dealDto.offPanelLenderNames;
    this.updateBuildArea(true);
    this.calculateContingency(true);

    if (this.dealDto.brokerOrganisationId) {
      this.getOrganisationbyDealId();
    }
  }

  keyPressEvent(event) {
    if (event.key === "Enter") {
      this.updatingName = false;
      this.submitForm(this.dealForm);
    }
    if (event.key === "Escape") {
      this.updatingName = false;
    }
  }

  submitForm(form: ng.IFormController = null) {
    this.dataLoading = true;

    const request: SaveDevFinanceSearchRequest = {
      clientId: null,
      deal: this.dealDto,
      shareDealDto: null,
      orgCode: "",
      enterpriseClientDto: null,
    };

    this.developmentFinanceDealClient
      .saveDevFinanceSearchReturnsId(request)
      .then((response) => {
        if (response != null) {
          if (form != null) form.$setPristine();
        }
      })
      .finally(() => {
        this.hasBuildCostsChanged = false;
        this.dataLoading = false;
      });
  }

  renameCase() {
    this.developmentFinanceCrudDealClient.patch({ id: this.dealDto.id, name: this.dealDto.name }).then((response) => {
      this.dataLoading = false;
      this.updatingName = false;
    });
  }

  closeModalAndGoToDasboard() {
    this.showTsAndCs = false;
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  closeModalAndGoToDealForum() {
    this.showTsAndCs = false;
    this.$location.path("/dealforum/" + this.dealDto.id);
  }

  closeModal(test: number) {
    this.messagebool = false;
  }

  getAddressList(searchTerm: string, postalAddress: PostalAddress) {
    let foundMatch = false;

    if (this.postCodeOptions && this.postCodeOptions.length > 0) {
      let addressLookup = this.postCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          for (let prop in address) {
            if (address.hasOwnProperty(prop)) {
              postalAddress[prop] = address[prop];
            }
          }
          this.searchterm = "";
          this.searchresults = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        postalAddress.addressLine1 = addressLookup.addressLine2.replace(
          addressLookup.addressLine2.substring(addressLookup.addressLine2.indexOf("-") - 1),
          "",
        );
        postalAddress.addressLine2 = addressLookup.addressLine3;
        postalAddress.postCode = addressLookup.addressLine1;
        this.searchterm = "";
        this.searchresults = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      this.postCodeOptions = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.postCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  /** Promotes/converts a search to a case */
  promoteSearchToCase() {
    this.dealClient
      .promoteSearchToCase({ dealId: this.dealId, productFamily: ProductFamilyEnum.Development })
      .then((response: PromoteSearchToCaseResponse) => {
        if (response != null && response.devFinanceDeal != null) {
          this.dealDto = response.devFinanceDeal;
          this.shortlistedLendersName = response.shortlistedLendersName;
          this.selectedLendersName = response.selectedLendersName;
          this.shortListedLendersId = response.shortlistedLendersId;
          this.postRetrieveProcessing();
          this.loadUserRolesAndDealIntegration();
        } else {
          this.message = "Problem while promoting a search to case, please try after some time.";
          this.showErrorMessage = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
        this.getLenderPortalLinks();
      });
  }

  getLenderPortalLinks() {
    this.dealLenderClient
      .fetchByDealId(this.$routeParams.dealId)
      .then((dls: DealLender[]) => {
        this.dealLenders = dls;
        const searchChanged = this.$routeParams.SearchChanged;
        const lenderIds = dls
          .filter(
            (dl) =>
              !dl.hasAppliedInLenderPortal &&
              (dl.status === CaseLenderStateEnum.Shortlisted || searchChanged == "true"),
          )
          .map((dl) => dl.lenderId);
        return this.lenderClient.getLenderPortalLinks(lenderIds);
      })
      .then((links) => {
        this.portalLinks = links;
      })
      .catch((error) => {
        this.message = "Error fetching lender portal links: " + error;
        this.portalLinks = null;
      })
      .finally(() => {
        this.showLenderPortalLinks = Object.keys(this.portalLinks).length > 0;
      });
  }

  openPortalLink(dealLenderId: number, url: string) {
    if (!this.portalLinkDetailsAdded[dealLenderId]) {
      this.dealLenderClient
        .addLenderPortalLinkDetails(dealLenderId, this.borrowerDetails)
        .then(() => {
          this.portalLinkDetailsAdded[dealLenderId] = true;
          this.openUrl(url);
        })
        .catch((error) => {
          console.error("Error adding lender portal link details:", error);
        });
    } else {
      this.openUrl(url);
    }
  }

  private openUrl(url: string) {
    if (!/^https?:\/\//i.test(url)) {
      url = "http://" + url;
    }
    window.open(url, "_blank");
  }

  saveOverview(): void {
    this.dealDto.projectDescription = this.caseOverview;

    this.developmentFinanceCrudDealClient
      .patch({ id: this.dealDto.id, projectDescription: this.dealDto.projectDescription })
      .then((response) => {
        this.dataLoading = false;
      });
  }

  gotoResultpage() {
    this.showErrorMessage = false;
    this.$location.path("/devfinanceresults/" + this.dealId);
  }

  onFileSelect(files: DealFileAttachment[], module: ModuleEnum) {
    if (!module) {
      module = ModuleEnum.Case;
    }

    const dealClientId = module == ModuleEnum.Track ? this.currentApplicant.id : 0;

    this.dealFileAttachmentHelper
      .UploadFileListInSync(files, this.uploadingFiles, this.dealDto.id, this.fileUpload, module, 0, dealClientId)
      .finally(() => {
        this.dataLoading = false;
      });
  }

  calculateTotalFiles(module: number) {
    if (module == ModuleEnum.Track) {
      this.total = this.fileUpload.filter(
        (item) => item.module === module && item.dealClientId == this.currentApplicant.id && !item.isDeleted,
      ).length;
    } else {
      if (this.fileUpload) {
        this.total = this.fileUpload.filter((item) => item.module === module && !item.isDeleted).length;
      }
    }

    return this.total;
  }

  calculateTotalFilesRemoving(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module != filter).length;
    }
    return this.total;
  }

  downloadFile(file: DealFileAttachment, downloadFile: boolean = false) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        if (downloadFile) {
          this.sharedDealService.downloadFile(uri, file.fileName);
        } else {
          this.$window.open(uri);
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  renameFile(file: DealFileAttachment) {
    if (this.renamingFile === undefined) {
      // if renaming this file will dirty the case, we'll want to set it back to pristine when we're done.
      // this.renamingFileDirties = !$scope.caseForm.$dirty;
      this.renamingFile = file;
    } else {
      delete this.renamingFile;
    }
  }
  renamingFileComplete(file: DealFileAttachment) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .fileRename(file)
      .then((response) => {
        file.tempURL = response.tempURL;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  renamingLinkCompleted(link: ExternalLinks) {
    this.dataLoading = true;
    this.externalLinksClient
      .addUpdate(link)
      .then((response) => {
        link.link = response.link;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  deleteFile(file: DealFileAttachment) {
    this.dealDto.attachments.splice(this.dealDto.attachments.indexOf(file), 1);
    this.dealFileAttachmentClient.markAsDeleted(file.id).then((result) => {}); //remove on the server
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders button is clicked*/
  showTermsAndConditionsForBorrower() {
    this.showApplyTsAndCs = true;
    this.requestMessageReason = "a review";
    this.showTsAndCs = true;
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders HoT button is clicked (borrower/broker) */
  showTermsAndConditions() {
    this.dataLoading = true;
    this.lenderClient
      .getShortlistedLendersInfoForSubmitToLenders(
        LenderProductTypeEnum.DevelopmentFinance,
        true,
        this.shortListedLendersId,
      )
      .then((response) => {
        this.lendersDetailsForSubmittoLenders = response;
      })
      .finally(() => {
        this.showTsAndCs = true;
        this.showTsAndCsForm = true;
        this.dealDto.submitTsAndCs = false;
        this.invalidEmail = false;
        this.dataLoading = false;
      });
  }

  gotoLendingPage() {
    (this.$rootScope as any).isLender = false;
    this.$location.path("/dealforum/" + this.dealDto.id);
  }

  /** Submits a case to lenders */
  submitCaseToLenders() {
    this.showTsAndCsForm = false;
    this.sendingMessage = true;
    this.dataLoading = true;
    var isResubmitting = false;

    if (this.dealDto.status == CaseStatusEnum.ReadyToReSubmit) {
      isResubmitting = true;
    }

    const request = {
      dealId: this.dealId,
      productType: this.dealDto.productType,
      resubmitToLenders: isResubmitting,
      brokerCommission: Number(this.brokerCommission),
      lendersInfo: this.lendersDetailsForSubmittoLenders,
      brokerPhoneNumber: this.brokerPreferredContact,
      isBrokerPhoneNumberUpdated: this.isBrokerPhoneNumberUpdated,
      offPanelLenderNames: this.offPanelLenderNames,
    } as SubmitToLendersRequest;

    this.dealClient
      .submitToLenders(request)
      .then((response: CaseChangedMessageDTO) => {
        this.dealDto.status = response.caseState;
        this.caseService.updateCaseState(this.dealDto.id, response.caseState);
        this.showMessage("You have requested a Decision in Principle from each lender.");
        this.isSubmittedToLenders = true;
      })
      .catch((error) => {
        this.showMessage("Sorry, something went wrong. Please try again.");
      })
      .finally(() => {
        this.sendingMessage = false;
        this.dataLoading = false;
      });
  }

  validateEmails() {
    this.invalidEmail = false;

    angular.forEach(this.lendersDetailsForSubmittoLenders, (lenderdetails, index) => {
      var emailField = this.lenderDetailsForm["email" + index];

      if (emailField && emailField.$invalid) {
        this.invalidEmail = true;
      }
    });
  }

  requestEmail(reason): void {
    this.showRequestEmailForm = true;
    this.requestMessageReason = reason;
    this.messagebool = true;
    this.messageContent = "";
  }

  getAppName() {
    let lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      this.appName = lsd;
    } else {
      this.appName = "Brickflow";
    }
  }

  closeConfirmationModal() {
    if (this.isSubmittedToLenders) {
      if (this.$routeParams.Promote) {
        this.$location.path("/devfinancecasedashboard/" + this.dealDto.id);
      } else {
        window.location.reload();
      }
    }
    this.showTsAndCs = false;
  }

  viewResults() {
    if (this.dealDto.status == CaseStatusEnum.NewCase || (!this.isAdmin && !this.isBroker)) {
      this.$location.path("/devfinanceresults/" + this.dealDto.id);
    } else {
      this.$location.path("/devfinanceshortlistmore/" + this.dealDto.id);
    }
  }

  /** Process the Heads of Terms button being clicked */
  headsOfTermsClicked() {
    sessionStorage.setItem("lenderTask", "terms");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  /** Lender rejects the case*/
  rejectButtonClicked() {
    sessionStorage.setItem("lenderTask", "reject");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  withDrawButtonClicked() {
    sessionStorage.setItem("lenderTask", "withdraw");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  feedbackButtonClicked() {
    sessionStorage.setItem("lenderTask", "feedback");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  //Share module functions
  openShareModuleModal(contextToShare: AppraisalModuleEnum) {
    this.shareContext = contextToShare;
    this.constructShareNoteMessage();

    this.dealClientClient.fetchDealMembersWithAccess(this.dealDto.id).then((response: Client[]) => {
      this.caseMembersWithAccess = response;

      this.showShare = true;
    });
  }

  sendToBorrower(selectedClient) {
    this.dataLoading = true;

    const request: ShareModuleRequest = {
      clientFirstName: selectedClient.client.firstName,
      clientLastName: selectedClient.client.lastName,
      clientEmail: selectedClient.client.email,
      dealName: this.dealDto.name,
      dealId: this.dealDto.id,
      productFamily: ProductFamilyEnum.Development,
    };

    this.dealClient.shareDealToBorrower(request).then((success) => {
      if (success) {
        this.dataLoading = false;
        this.message =
          "The deal has been successfully shared with " +
          selectedClient.client.firstName +
          " " +
          selectedClient.client.lastName +
          ".";
      } else {
        this.message = "Sorry, something went wrong. Please try again.";
      }
      this.modal = true;
    });
  }

  isShareNoteFormComplete(): boolean {
    return this.selectedClientToShareWith && this.shareNote && this.shareNote.length > 0 ? true : false;
  }

  //End of Share module functions

  // Profile view functions

  /**
   * Show the Add/Edit permissions profile modal
   * @param applicant
   */
  showPermissionsProfileModal(profile: DealClient = null, isEdit: boolean = null): void {
    this.showMaximumApplicantsMessage = false;

    if (isEdit) {
      this.newApplicant = profile;
      this.isAddShareholder = false;
      this.showAddorEdit = true;
    } else {
      this.newApplicant = {} as DealClient;
      this.isAddShareholder = true;
      this.newApplicant.accessLevel = CaseAccessLevelEnum.Hidden;
      this.showAddorEdit = true;
    }
  }

  resetApplicant() {
    this.applicantForm.$setPristine();
    this.applicantForm.$setUntouched();
    this.newApplicant = {} as DealClient;
    this.showAddorEdit = false;
  }

  /**
   * Saves the applicant being added/edited
   */
  saveApplicant(formController) {
    this.dataLoading = true;

    if (!(this.currentApplicant.id > 0)) {
      this.currentApplicant.isApplicant = true;
      this.currentApplicant.dealId = this.dealDto.id;
      this.currentApplicant.accessLevel = CaseAccessLevelEnum.Hidden;
    }

    this.currentApplicant.uniqueRef = this.currentApplicant.uniqueRef ?? "";
    this.currentApplicant.accessLevel = this.currentApplicant.accessLevel ?? CaseAccessLevelEnum.Hidden;
    this.currentApplicant.ownershipPercentage = this.currentApplicant.ownershipPercentage ?? 0;
    this.currentApplicant.ownershipRole = this.currentApplicant.ownershipRole ?? OwnershipRoleEnum.None;
    this.currentApplicant.client =
      this.currentApplicant.client ??
      ({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        postalAddress: {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        },
      } as Client);
    this.currentApplicant.deal = this.currentApplicant.deal ?? null;

    this.saveUpdatedApplicant(this.currentApplicant, false, formController);
  }

  /**
   * Add or update a applicant
   * @param applicant
   */
  saveUpdatedApplicant(applicant: DealClient, isPermissionsProfile: boolean = false, formController = null): void {
    this.dataLoading = true;

    this.disableQuickEditSave = true; // this is just because sometimes the save takes a little while and the user could click the save button again
    applicant.dealId = this.dealDto.id;

    //Below code is added for upgrade
    if (!(applicant.id > 0)) {
      applicant.deal = null;
      applicant.clientId = 0;
    }

    if (applicant.client) {
      applicant.client.phoneNumber ??= "";
      applicant.client.email ??= "";

      if (applicant.client.postalAddress != null) {
        applicant.client.postalAddress.addressLine1 ??= "";
        applicant.client.postalAddress.addressLine2 ??= "";
        applicant.client.postalAddress.addressLine3 ??= "";
        applicant.client.postalAddress.addressLine4 ??= "";
        applicant.client.postalAddress.postCode ??= "";
      }
    }
    // End of upgrade changes
    if (applicant) {
      this.dateProperties.forEach((property) => {
        let val = applicant[property];
        if (val) {
          applicant[property] = this.modifyDateForBackend(val);
        }
      });
    }

    if (applicant.profile) {
      this.profileDateProperties.forEach((property) => {
        let val = applicant.profile[property];
        if (val) {
          applicant.profile[property] = this.modifyDateForBackend(val);
        }
      });

      if (applicant.profile.postalAddress == null) {
        applicant.profile.postalAddress = {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
      }
      applicant.profile.profileUsers = applicant.profile.profileUsers ?? [];
      applicant.profile.qualifications = applicant.profile.qualifications ?? [];
      applicant.profile.assetLiabilityItems = applicant.profile.assetLiabilityItems ?? [];
    }

    if (applicant.client) {
      this.clientDateProperties.forEach((property) => {
        let val = applicant.client[property];
        if (val) {
          applicant.client[property] = this.modifyDateForBackend(val);
        }
      });

      if (
        (!applicant.client?.postalAddress && isPermissionsProfile) ||
        (!this.isAddShareholder && !applicant.client?.postalAddress && !applicant.id)
      ) {
        applicant.client.postalAddress = {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
      }
    }

    this.dealClientClient
      .addorUpdateApplicant(this.isAddShareholder, applicant)
      .then((response) => {
        this.dataLoading = true;

        if (response) {
          this.dateProperties.forEach((property) => {
            let val = response[property];
            if (val) {
              response[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        if (response.profile) {
          this.profileDateProperties.forEach((property) => {
            let val = response.profile[property];
            if (val) {
              response.profile[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        if (response.client) {
          this.clientDateProperties.forEach((property) => {
            let val = response.client[property];
            if (val) {
              response.client[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        const existingShareholder = this.applicantList.find((s) => s.id == response.id);

        // If found then we're updating
        if (existingShareholder) {
          this.applicantList = this.applicantList.filter((member) => member.id != applicant.id);
          this.applicantList.push(response);
        } else {
          this.applicantList.push(response);
        }
        if (!isPermissionsProfile) {
          this.currentApplicant = response;
          formController.$setPristine();
        }
      })
      .finally(() => {
        delete this.newApplicant;
        this.showAddorEdit = false;
        this.disableQuickEditSave = false;
        this.dataLoading = false;
      });
  }

  cancelUpdateApplicant() {
    this.showAddorEdit = false;
    this.applicantList = this.applicantList.filter((applicant) => applicant.id != this.newApplicant?.id);
    this.applicantList.push(this.newApplicant); // Resets anything that is changed using the original data object
  }

  deleteApplicant(): void {
    this.dataLoading = true;
    this.dealClientClient
      .markAsDeleteAndSetNextApplicantAsPrimary(this.dealDto.id, this.confirmDeleteApplicant.id)
      .then((response) => {
        this.applicantList = response;
      })
      .finally(() => {
        this.dataLoading = false;
        this.confirmDeleteApplicant = {} as DealClient;
        this.showDelete = false;
      });
  }

  deleteConfirmApplicant(applicant: DealClient) {
    this.showDelete = true;
    this.confirmDeleteApplicant = applicant;
  }

  nonUkWarningVisible(): boolean {
    return this.sharedDealService.nonUkWarningVisible(this.currentApplicant);
  }

  showInviteButton(shareholder: DealClient) {
    return this.sharedDealService.showInviteButton(shareholder);
  }

  invite(applicant: DealClient) {
    this.dataLoading = true;

    this.dealClientClient
      .inviteApplicant(applicant.uniqueRef)
      .then((i) => {
        this.modal = true;
        this.message =
          "A request has been sent to " +
          applicant.client.firstName +
          " " +
          applicant.client.lastName +
          " complete their shareholder profile.";
      })
      .catch((error) => {
        this.modal = true;
        this.message =
          "There was a problem sending the invite request to " +
          applicant.client.firstName +
          " " +
          applicant.client.lastName +
          ". Please try again later.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  //End of Profile view functions

  /** Show and hide the export menu */
  showAndHideExport() {
    this.showExport = !this.showExport;
  }

  modifyDateForBackend(property: Date) {
    return this.sharedDealService.modifyDateForBackend(property);
  }

  modifyDateForFrontend(property: Date) {
    return this.sharedDealService.modifyDateForFrontend(property);
  }

  goToUserDashboard() {
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  // Setting the dependent data when option are changed
  clearSearchdata() {
    this.dealDto = this.devFinanceDealService.clearSearchdata(this.dealDto);
  }

  datasetupOnOwnOrPurchaseChange() {
    this.dealDto = this.devFinanceDealService.datasetupOnOwnOrPurchaseChange(this.dealDto);
    this.scheduleAutosave("ownOrPurchase", this.dealDto.ownOrPurchase, null);
  }

  datasetupOnIsTenantedBuildingChange() {
    if (!this.dealDto.isTenantedBuilding) this.leaseItems = null;
    this.dealDto = this.devFinanceDealService.datasetupOnIsTenantedBuildingChange(this.dealDto);
  }

  datasetupOnMaxLoanRequiredChange() {
    this.dealDto = DealHelper.dataSetupOnMaxLoanRequiredChange(this.dealDto);
    this.scheduleAutosave("netLoanRequired", this.dealDto.netLoanRequired, null);
    this.scheduleAutosave("maxLoanRequired", this.dealDto.maxLoanRequired, null);
  }

  onPropertyTabSelection() {
    if (this.dealDto) {
      this.showAppraisalPermission = false;
      this.selectedNavMenu = this.CaseDashboardTypeEnum.Property;
      this.scrollTo("propertySection");
      this.onTabSelection();
    }
  }

  onLoanTabSelection() {
    if (this.dealDto) {
      this.showAppraisalPermission = false;
      this.selectedNavMenu = this.CaseDashboardTypeEnum.Loan;
      this.scrollTo("loanSection");
      this.onTabSelection();
    }
  }

  onTabSelection() {
    this.tempDealDto = JSON.parse(JSON.stringify(this.dealDto));
  }

  trustedHtml(plainText) {
    return this.$sce.trustAsHtml(plainText);
  }

  onIsMortgagedChange() {
    if (!this.dealDto.isMortgaged) {
      this.dealDto.mortgageCurrentLender = null;
      this.dealDto.mortgageCurrentBalance = 0;
    }
  }

  goToLoanTypeSelectionPage() {
    if (this.isLoggedInUser) {
      this.authService.setHasValidStatustoShowShareSearchModal(true);
    }
    this.$location.path("/allloans");
  }

  isValidDeal() {
    if (this.dealDto === null || this.dealDto === undefined) return true;

    if (this.dealForm && this.dealForm.$invalid) return true;

    if (
      this.dealDto.propertyAddress == null ||
      this.dealDto.propertyAddress.addressLine1 == null ||
      this.dealDto.propertyAddress.addressLine1.length <= 0 ||
      this.dealDto.propertyAddress.postCode == null ||
      this.dealDto.propertyAddress.postCode.length <= 0
    ) {
      return true;
    }

    const commonFields = [
      this.dealDto.ownOrPurchase,
      this.dealDto.purchasePrice,
      this.dealDto.endPropertyType,
      this.dealDto.chargeRequired,
      this.dealDto.borrowingEntityType,
    ];

    if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
      commonFields.push(this.dealDto.currentvalue);
    }

    if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
      if (this.dealDto.purchaseCosts == null) return true;
    }

    for (let i = 0; i < commonFields.length; i++) {
      if (commonFields[i] == null || commonFields[i] == 0) {
        return true;
      }
    }

    return false;
  }

  initMortgageTerm() {
    this.dealDto.loanTermReq = this.dealDto.loanTermReq || 240;
    this.mortgageTerm = this.dealDto.loanTermReq / 12;
  }

  mortgageTermToLoanTerm() {
    this.dealDto.loanTermReq = this.mortgageTerm * 12;
  }

  /**
   * Calculates the order number of all the preferences when one is toggled
   * @param toggledPreference
   */
  calculatePreferenceOrder(toggledPreference: string) {
    const preferenceNames = [
      "searchPreferenceLoanSize",
      "searchPreferencePricing",
      "searchPreferenceCompletionSpeed",
      "searchPreferenceCustomerService",
    ];
    // Finds the highest preference order of all preferences
    const maxPreferenceOrder = Math.max(
      this.dealDto.searchPreferenceCompletionSpeed,
      this.dealDto.searchPreferenceCustomerService,
      this.dealDto.searchPreferenceLoanSize,
      this.dealDto.searchPreferencePricing,
    );

    // If the preference that has been toggled already has a value greater than 0 then it is being turned OFF
    if (this.dealDto[toggledPreference] > 0) {
      // Find any preferences that have a higher preference number and decrease their order number by 1
      for (let preference of preferenceNames) {
        if (preference == toggledPreference) {
          continue;
        } else {
          if (this.dealDto[preference] > this.dealDto[toggledPreference]) {
            this.dealDto[preference]--;
          }
        }
      }

      this.dealDto[toggledPreference] = 0;
    } else {
      // Preference is being turned ON
      // Use the highest preference order number and increase by 1
      this.dealDto[toggledPreference] = maxPreferenceOrder + 1;
    }
  }

  CalcTotalPurchaseCosts(): number {
    var res: number = 0;
    if (this.dealDto.purchasePrice) {
      res += Number(this.dealDto.purchasePrice);
    }
    if (this.dealDto.stampDutyLandTax) {
      res += Number(this.dealDto.stampDutyLandTax);
    }
    if (this.dealDto.purchaseLegalFees) {
      res += Number(this.dealDto.purchaseLegalFees);
    }
    if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing && this.dealDto.purchaseCosts) {
      res += Number(this.dealDto.purchaseCosts);
    }

    if (this.dealDto.payingVATOnLandPurchase === 1) {
      res += Number(this.dealDto.landPurchaseVatAmount);
    }

    this.totalPurchaseCosts = res;
    return res;
  }

  onOwnOrPurchaseChange(OwnOrPurchase: boolean) {
    this.dealDto.ownOrPurchase = this.dealDto.hasOwnOrPurchase ? OwnOrPurchaseEnum.Own : OwnOrPurchaseEnum.Purchasing;
    this.scheduleAutosave("ownOrPurchase", this.dealDto.ownOrPurchase, null);
    //TODO need a review for this function
    this.datasetupOnOwnOrPurchaseChange();
  }

  updateVatOnLandPurchase(PayingVATOnLandPurchase): void {
    this.dealDto.payingVATOnLandPurchase = PayingVATOnLandPurchase;
    if (this.dealDto.payingVATOnLandPurchase === 1) {
      //if yes, show vat amount question prepopulated with 20% of purchase price
      this.dealDto.landPurchaseVatAmount = this.dealDto.purchasePrice * 0.2;
      this.CalcTotalPurchaseCosts();
    }
  }

  updateBuildArea(initial: boolean = false) {
    if (this.dealDto.areaUnit == AreaUnitEnum.SquareFeet) {
      this.dealDto.buildCostPerArea = this.buildCostPerSqFt;
      this.buildCostPerSqM = Number(this.convertSqFtToSqM(this.buildCostPerSqFt).toFixed(2));
    } else {
      this.dealDto.buildCostPerArea = this.buildCostPerSqM;
      this.buildCostPerSqFt = Number(this.convertSqMToSqFt(this.buildCostPerSqM).toFixed(2));
    }
    if (!initial) {
      if (this.dealDto.buildCostPerArea != null && this.isNumber(this.dealDto.buildCostPerArea)) {
        this.scheduleAutosave("buildCostPerArea", this.dealDto.buildCostPerArea, null);
      }
      this.calculateBuildCostIntermediary();
    }
  }

  convertSqMToSqFt(costPerSqM: number): number {
    return costPerSqM / this.areaConversionFactor;
  }

  convertSqFtToSqM(costPerSqFt: number): number {
    return costPerSqFt * this.areaConversionFactor;
  }

  calculateBuildCostIntermediary() {
    if (this.dealDto.grossInternalAreaKnown && this.dealDto.buildCostPerArea > 0 && this.dealDto.areaAcquisition > 0) {
      this.buildCostIntermediary = this.dealDto.areaAcquisition * this.dealDto.buildCostPerArea;
    }
    this.calculateContingency();
  }

  updateGIA() {
    this.scheduleAutosave("areaAcquisition", this.dealDto.areaAcquisition, this.dealForm.areaAcquisition);
    this.calculateBuildCostIntermediary();
  }

  updateContingency() {
    this.calculateContingency();
  }

  toggleKnowsGIA() {
    this.dealDto.grossInternalAreaKnown = !this.dealDto.grossInternalAreaKnown;
    if (this.dealDto.grossInternalAreaKnown == true) {
      this.dealDto.areaUnit = AreaUnitEnum.SquareFeet;
    } else {
      this.dealDto.areaAcquisition = null;
      this.dealDto.areaUnit = null;
      this.buildCostPerSqFt = null;
      this.buildCostPerSqM = null;
      this.dealDto.buildCostPerArea = null;
    }
    this.scheduleAutosave("grossInternalAreaKnown", this.dealDto.grossInternalAreaKnown, null);
    this.buildCostIntermediary = null;
    //this.buildCostsForm.buildCostIntermediary.$setUntouched();
    this.updateContingency();
  }

  calculateContingency(initial = false) {
    if (this.dealDto.includesContingency) {
      this.contingencyValue =
        this.buildCostIntermediary - this.buildCostIntermediary / (1 + Number(this.dealDto.contingency));
    } else {
      this.contingencyValue = this.buildCostIntermediary * this.dealDto.contingency;
    }
    this.calculateTotalBuildCost(initial);
  }

  calculateTotalBuildCost(initial = false) {
    if (this.dealDto.includesContingency) {
      this.totalBuildCosts = this.buildCostIntermediary;
      this.dealDto.buildCosts = Number(this.buildCostIntermediary) - this.contingencyValue;
    } else {
      this.totalBuildCosts = Number(this.buildCostIntermediary) + this.contingencyValue;
      this.dealDto.buildCosts = Number(this.buildCostIntermediary);
    }

    if (!initial && this.dealDto.buildCosts != null && this.isNumber(this.dealDto.buildCosts))
      this.scheduleAutosave("buildCosts", this.dealDto.buildCosts, null);
    this.calculateTotalProjectCosts(initial);
  }

  calculateTotalProjectCosts(initial = false) {
    let totalCosts = 0;

    if (isNaN(Number(this.dealDto.additionalOngoingCosts)) == false) {
      totalCosts += Number(this.dealDto.additionalOngoingCosts);
    }

    if (isNaN(Number(this.totalBuildCosts)) == false) {
      totalCosts += Number(this.totalBuildCosts);
    }

    if (isNaN(Number(this.dealDto.purchasePrice)) == false) {
      totalCosts += Number(this.dealDto.purchasePrice);
    }

    this.dealDto.totalProjectCosts = totalCosts;

    if (!initial && this.dealDto.totalProjectCosts != null && this.isNumber(this.dealDto.totalProjectCosts))
      this.scheduleAutosave("totalProjectCosts", this.dealDto.totalProjectCosts, null);
  }

  getTenureText(tenureValue) {
    var value = null;
    switch (tenureValue) {
      case TenureEnum.Freehold:
        value = "Freehold";
        break;
      case TenureEnum.Leasehold:
        value = "Leasehold";
        break;
      case TenureEnum.Other:
        value = "Other";
        break;
      default:
        break;
    }
    return value;
  }

  calculatePricePerUnit(scheduleRow) {
    if (scheduleRow.salesPrice != null && scheduleRow.area != null) {
      return Number(scheduleRow.salesPrice) / scheduleRow.area;
    } else {
      return 0;
    }
  }

  getFilesByModule(module) {
    if (module == ModuleEnum.Track) {
      return this.fileUpload.filter((item) => item.module === module && item.dealClientId == this.currentApplicant.id);
    } else {
      return this.fileUpload.filter((item) => item.module === module);
    }
  }

  updateDealDto(successmessage: string = "") {
    this.dataLoading = false;
    this.developmentFinanceDealClient
      .addUpdateReturnOnlyID(this.dealDto)
      .then((dealId) => {
        if (successmessage.length > 0) {
          this.showMessage(successmessage);
          this.showSuccessorFailureMessage = true;
        }
      })
      .catch((error) => {
        if (successmessage.length > 0) {
          this.dealDto.gdv = this.tempGDV;
          this.dealDto.areaAcquisition = this.tempAreaAcquisition;
        }
        this.showMessage("Sorry, something went wrong. Please try again.");
        this.showSuccessorFailureMessage = true;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  getOrganisationbyDealId() {
    this.organisationClient.getOrganisationAndBrokerByDealId(this.dealDto.id).then((response) => {
      this.org = response.organisation;
      this.dealBrokerUser = response.broker;
      this.brokerCommission =
        this.dealDto.status == CaseStatusEnum.NewCase
          ? this.org?.commissionPercent
          : this.dealDto.brokerCommissionPercent;
      this.brokerPreferredContact =
        this.dealDto.status == CaseStatusEnum.NewCase ? response.broker.phoneNumber : this.dealDto.brokerPhoneNumber;
      if (this.org.isWhiteLabelled) {
        this.fileNamePrefix = this.org.name.replace(/ /g, "_");
      } else {
        this.fileNamePrefix = "Brickflow";
      }
    });
  }

  getOwnershipPercentageText() {
    if (this.dealDto != null) {
      return this.sharedDealService.getOwnershipPercentageText(this.currentApplicant, this.dealDto.productType);
    }
    return "Shareholding";
  }

  closeSubmitToLenderModal() {
    this.showTsAndCs = false;
    this.brokerCommission =
      this.dealDto.status == CaseStatusEnum.NewCase
        ? this.org?.commissionPercent
        : this.dealDto.brokerCommissionPercent;
    this.brokerPreferredContact =
      this.dealDto.status == CaseStatusEnum.NewCase ? this.dealBrokerUser?.phoneNumber : this.dealDto.brokerPhoneNumber;
    this.isBrokerPhoneNumberUpdated = false;
  }

  showBasedOnMainResidence() {
    return DealHelper.showBasedOnMainResidence(this.dealDto);
  }

  checkBrokerDeal() {
    return this.dealDto?.brokerUserId != null && this.isClient ? true : false;
  }

  goToUserDashboardEquityAndMezz() {
    this.userDashboardService.setGoToNavMenu(5);
    this.$location.path("/userdashboard");
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions(true, this.isReadOnlyDeal);
  }

  logExportDownload(eventName) {
    this.eventLogClient.logEvent(eventName, EventLogEnum.Export, this.dealDto.productType, this.dealDto.id);
  }

  getTinymceOptions = function () {
    return this.isLender || this.isReadOnlyDeal ? this.tinymceReadonlyOptions : this.tinymceOverviewOptions;
  };

  initializeNewScheduleData() {
    return {
      description: ScheduleDescriptionTypeEnum.DetachedHouse,
      bedCount: 0,
      tenure: TenureEnum.Freehold,
      salesPrice: 0,
      area: 0,
      preAgreement: PreAgreementEnum.None,
      annualRent: 0,
      scheduleType: ScheduleTypeEnum.House,
      deal: null,
      id: 0,
      dealId: this.dealDto.id,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: null,
      createdUserId: null,
      createdUser: null,
    };
  }

  async loadUserRolesAndDealIntegration() {
    await this.getCurrentUserAndRoles();

    if (this.isBroker || this.isAdmin) {
      this.organisationClient.getOrganisationProductAccess().then((response) => {
        this.isDeallockerIntegrationEnabled = response.isDeallockerIntegrationEnabled;
      });
    }
  }

  confirmTabChangeWithSave() {
    this.saveOverview();
    if (this.pendingTabCallback) {
      this.pendingTabCallback.call(this);
    }
    this.resetUnsavedChangePrompt();
  }

  selectPropertyTab() {
    this.goToTab(2, this.onPropertyTabSelection);
  }

  selectLoanTab() {
    this.goToTab(3, this.onLoanTabSelection);
  }

  openCasePermissions() {
    this.goToTab("appraisalPermission", function () {
      this.showAppraisalPermission = true;
    });
  }

  openRequestAssistance() {
    this.goToTab("requistAssistance", function () {
      this.requestEmail("assistance");
    });
  }

  handleTermsAndConditions() {
    this.goToTab("termsAndConditions", function () {
      this.showTermsAndConditions();
    });
  }

  handleDealForum() {
    this.goToTab("dealForum", function () {
      this.gotoLendingPage();
    });
  }

  handeShareModuleModal(sectionId) {
    this.goToTab("shareModule:" + sectionId, function () {
      this.openShareModuleModal(sectionId);
    });
  }

  handleViewResults() {
    this.goToTab("viewResults", function () {
      this.viewResults();
    });
  }

  handleEditDealName() {
    this.goToTab("editDealName", function () {
      this.editDealName();
    });
  }

  // Flush function (actually sends PATCH)
  flushAutosave() {
    //if (this.skipAutosave) return;

    if (Object.keys(this.pendingChanges).length > 1) {
      // more than just id
      const updatePayload: DevelopmentFinanceDealUpdate = { ...this.pendingChanges };

      this.developmentFinanceCrudDealClient.patch(updatePayload).then(() => {
        this.pendingChanges = { id: this.dealDto.id }; // reset after save
      });
    }
  }

  isNumber(value) {
    return typeof value === "number" && !isNaN(value);
  }
}
